var map = {
	"./01-01.mp3": 490,
	"./01-01__.mp3": 766,
	"./01-02.mp3": 767,
	"./01-03.mp3": 360,
	"./01-04.mp3": 361,
	"./01-05.mp3": 491,
	"./01-06.mp3": 768,
	"./01-07.mp3": 769,
	"./01-08.mp3": 770,
	"./01-09.mp3": 771
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1470;